<template>
  <div id="navbar">
    <div class="menu-item" v-for="(item, idx) in items" :key="idx" @click="navigate(item)" :class="selectedTab.id == item.id ? 'selected-menu-item' : ''">
      <p v-if="!isMobile">{{item.display}}</p>
      <img v-else :src="item.icon">
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      selectedTab: {display: "Hjem", id: "front-page", icon: "https://i.imgur.com/DoOVIid.png"},
      items: [ 
        {display: "Hjem", id: "front-page", icon: "https://i.imgur.com/DoOVIid.png"}, 
        {display: "Overnatting", id: "hotel", icon: "https://i.imgur.com/XIUnGuj.png"}, 
        {display: "Gaver", id: "gifts", icon: "https://i.imgur.com/FVlirto.png"}, 
      ],
      windowWidth: window.innerWidth,
    }
  },
  computed: { 
    isMobile() {
      return this.windowWidth <= 900
    }
  },
  methods: {
    navigate (item) {
      this.$emit('navigate', item.id)
      this.selectedTab = item
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      })
    })
  }
}
</script>

<style lang="scss">
  #navbar {
    height: 64px;
    margin: auto;
    background-color: black;
    color: white;
    text-align: center;
    z-index: 3;
    position: fixed;
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    left: 0;
  }
  .menu-item {
    display: inline-block;
    padding: 1em 10px;
    font-family: 'Courier New', Courier, monospace;
    font-size: 20px;
    line-height: 24px;
    &:hover, &.selected-menu-item {
      background: #444;
      cursor: pointer;
    }
    @media screen and (max-width: 900px){
      margin: 0 2%;
      padding: 5px 2%;
      position: relative;
    }

    & > img {
      width: 48px;
      max-width: 20vw;
      filter: opacity(0.5);
    }
  }
</style>
